













import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
  computed: {
    ...mapGetters({
      isMobile: "ui/isMobile",
      isTablet: "ui/isTablet",
      isDesktop: "ui/isDesktop",
      isWidescreen: "ui/isWidescreen",
      isFullHd: "ui/isFullHd"
    })
  }
})
export default class UPadding extends Vue {
  private isMobile!: boolean;
  private isTablet!: boolean;
  private isDesktop!: boolean;
  private isWidescreen!: boolean;
  private isFullHd!: boolean;
  // Props
  @Prop({ required: false, default: "div" })
  public tag!: string;
  @Prop({ required: false, default: true })
  public x!: boolean | string[];
  @Prop({ required: false, default: true })
  public y!: boolean | string[];
  // Getters
  public get hasPaddingX() {
    if (this.$_.isBoolean(this.x)) return this.x;
    this.x = this.x as string[];
    if (this.isMobile) return this.x.includes("mobile");
    if (this.isTablet) return this.x.includes("tablet");
    if (this.isDesktop) return this.x.includes("desktop");
    if (this.isWidescreen) return this.x.includes("widescreen");
    if (this.isFullHd) return this.x.includes("fullhd");
    return true;
  }
  public get hasPaddingY() {
    if (this.$_.isBoolean(this.y)) return this.y;
    this.y = this.y as string[];
    if (this.isMobile) return this.y.includes("mobile");
    if (this.isTablet) return this.y.includes("tablet");
    if (this.isDesktop) return this.y.includes("desktop");
    if (this.isWidescreen) return this.y.includes("widescreen");
    if (this.isFullHd) return this.y.includes("fullhd");
    return true;
  }
}
